import React from "react";
import { Box, Typography, Grid, CardContent } from "@mui/material";
import { Documento } from "../../../types/processo/Documento";
import ProtectedImage from "../../orgao/ProtectedImage";

type Props = {
  documento: Documento;
};

const CabecalhoDocumentos = ({ documento }: Props) => {
  //pegar o usario logado aqui e seu setor.

  return (
    <Box
      sx={{
        padding: 2,
        display: "flex",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#e8e2e2", // Cor de fundo amarela
        borderRadius: 1, // Bordas arredondadas
        boxShadow: 3, // Sombra para destacar o cabeçalho          
        maxWidth: "100%", // Garante que o cabeçalho não ultrapasse a largura do container
        overflow: "hidden", // Evita que o conteúdo transborde
        wordWrap: "break-word", // Quebra palavras longas para evitar transbordamento
      }}
    >
      {/* Usando Grid para organizar logo e texto */}
      <Grid container alignItems="center" spacing={2}>
        {/* Logo */}
        <Grid item>
          {documento.orgao && documento.orgao.logo && (
            <ProtectedImage
              filename={documento.orgao?.logo}
              style={{
                width: "150px", // Tamanho da logo
                height: "auto", // Mantém a proporção da imagem
                objectFit: "contain", // Garante que a imagem não seja distorcida
              }}
            />
          )}
        </Grid>

        {/* Texto de informações do cabeçalho */}
        <Grid item xs>
          <Typography variant="h5" fontWeight="bold">
            {documento.orgao && `${documento.orgao.nome}`}
          </Typography>
          <Typography variant="h6">
            {documento.setor?.secretaria &&
              `${documento.setor.secretaria.nome}`}
          </Typography>
          <Typography variant="body1">
            {documento.setor && `${documento.setor.nome}`}
          </Typography>
          <Typography variant="body1">
            {documento.setor?.endereco &&
              `Endereço: ${documento.setor.endereco}, ${documento.setor.numero}, ${documento.setor.bairro}, ${documento.setor.cidade} - CEP: ${documento.setor.cep}`}
          </Typography>
          <Typography variant="body1">
            {documento.setor &&
              `${
                documento.setor.telefone
                  ? `Telefone: ${documento.setor.telefone}`
                  : ""
              }`}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CabecalhoDocumentos;
